import { Instagram, Facebook, Clock, Wallet } from "lucide-react";
import { usePublicLang } from "@/contexts/PublicLangContext";
import { LANDING } from "@/constants/testIds";
import { PAYMENT_METHOD_LABELS } from "@/lib/patientConstants";

export default function LandingFooter({ clinic }) {
  const { t, lang } = usePublicLang();
  const hasSocial = clinic.instagram_url || clinic.facebook_url;

  return (
    <footer className="py-12 px-5 text-center flex flex-col items-center gap-4 border-t border-black/5 bg-white" data-testid={LANDING.footer}>
      <span className="font-serif text-xl text-[#292522]">{clinic.name}</span>
      {hasSocial && (
        <div className="flex items-center gap-4">
          {clinic.instagram_url && (
            <a href={clinic.instagram_url} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center text-[var(--brand-primary)] hover:scale-105 transition-transform" data-testid={LANDING.footerInstagram}>
              <Instagram className="w-5 h-5" />
            </a>
          )}
          {clinic.facebook_url && (
            <a href={clinic.facebook_url} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-[var(--brand-secondary)] flex items-center justify-center text-[var(--brand-primary)] hover:scale-105 transition-transform" data-testid={LANDING.footerFacebook}>
              <Facebook className="w-5 h-5" />
            </a>
          )}
        </div>
      )}
      <div className="text-sm text-[#6B6058] space-y-1">
        {clinic.address && <p>{clinic.address}</p>}
        {clinic.phone && <p>{clinic.phone}</p>}
        {clinic.email && <p>{clinic.email}</p>}
        {clinic.business_hours_text && (
          <p className="flex items-start gap-1.5 justify-center whitespace-pre-line"><Clock className="w-3.5 h-3.5 shrink-0 mt-0.5" />{clinic.business_hours_text}</p>
        )}
        {clinic.accepted_payment_methods?.length > 0 && (
          <p className="flex items-center gap-1.5 justify-center" data-testid={LANDING.footerPaymentMethods}>
            <Wallet className="w-3.5 h-3.5" />
            Aceptamos {clinic.accepted_payment_methods.map((m) => PAYMENT_METHOD_LABELS[m] || m).join(", ")}
          </p>
        )}
      </div>
      <p className="text-xs text-[#6B6058]/70 max-w-md">{t("landing.footer.legal")}</p>
      <p className="text-xs text-[#6B6058]/60">{clinic.name} — {t("footer.rights")}</p>
      {/* Fix L (2026-09-25): enlace a la politica de privacidad */}
      <a href={lang === "en" ? "/privacy" : "/privacidad"} className="text-xs text-[#6B6058]/70 underline hover:text-[#292522]">
        {lang === "en" ? "Privacy Policy" : "Política de privacidad"}
      </a>
    </footer>
  );
}
